// services/sales/ConsumerFinalSaleService.ts
import { consumerFinalSaleApi } from '../../api';
import { SaleProductDTO } from '../../types/sale/SaleProductDTO';

const ConsumerFinalSaleService = {
  /**
   * POST /api/consumer-final-sales/products
   * Agrega un producto a una venta consumidor final.
   */
  addProduct: async (product: SaleProductDTO) => {
    const response = await consumerFinalSaleApi.addCustom('/products', product);
    return response.data;
  },

  /**
   * PUT /api/consumer-final-sales/products
   * Actualiza un producto de una venta consumidor final.
   */
  updateProduct: async (product: SaleProductDTO) => {
    const response = await consumerFinalSaleApi.modifyCustom('/products', product);
    return response.data;
  },

  /**
   * DELETE /api/consumer-final-sales/products/{detailId}
   * Elimina un producto de una venta consumidor final.
   */
  deleteProduct: async (detailId: number) => {
    const response = await consumerFinalSaleApi.removeCustom(`/products/${detailId}`);
    return response.data;
  },

  /**
   * GET /api/consumer-final-sales/products/{detailId}
   * Obtiene un producto para edición.
   */
  getProductById: async (detailId: number) => {
    const response = await consumerFinalSaleApi.fetchCustom(`/products/${detailId}`);
    return response.data;
  },
};

export default ConsumerFinalSaleService;
